module.exports = __webpack_public_path__ + "static/media/email.04bd53d7.png";